import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRouter from "./utils/router/AppRouter";
import useAxiosInterceptors from "./utils/setupAxiosInterceptors";

function App() {
  useAxiosInterceptors();
  return (
    <>
      <AppRouter />
      <ToastContainer
        position="top-right"
        autoClose={4000}
        newestOnTop
        closeOnClick
        pauseOnHover
        limit={5}
        style={{ zIndex: 2147483647 }}
      />
    </>
  );
}

export default App;
